import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_KEY } from '../types';

/**
 * Snapshot of the URL fragment as the page loaded.
 *
 * createClient() runs at import time and, with detectSessionInUrl enabled
 * (the default), consumes and clears the `#access_token=...&type=recovery`
 * fragment before React mounts. Anything reading window.location.hash from a
 * useEffect can therefore miss it, so capture it here first.
 */
export const initialUrlHash: string =
  typeof window !== 'undefined' ? window.location.hash : '';

export const isRecoveryRedirect: boolean = initialUrlHash.includes('type=recovery');

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
